import {
  ON_GET_INVOICES,
  GET_INVOICES,
  INVOICE_ERROR,
  ON_GET_INVOICE_DETAIL,
  GET_INVOICE_DETAIL,
  ON_CHARGE_INVOICE,
  CHARGE_INVOICE_SUCCESS,
  CHARGE_INVOICE_ERROR,
  ON_UPDATE_INVOICE_STATUS,
  UPDATE_INVOICE_STATUS_SUCCESS,
  UPDATE_INVOICE_STATUS_ERROR,
  GET_INVOICE_PERIODS,
} from "../../actions/types";

const initialState = {
  invoices: { data: [], recordsTotal: 0, hasMore: false },
  invoiceDetail: null,
  periods: [],
  loading: true,
  loadingDetail: true,
  charging: false,
  chargeError: null,
  updatingStatus: false,
  statusError: null,
  error: null,
};

export default function invoiceReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case ON_GET_INVOICES:
      return { ...state, loading: true, error: null };
    case GET_INVOICES:
      return { ...state, invoices: payload, loading: false };
    case ON_GET_INVOICE_DETAIL:
      return { ...state, loadingDetail: true, error: null };
    case GET_INVOICE_DETAIL:
      return { ...state, invoiceDetail: payload, loadingDetail: false, statusError: null };
    case ON_CHARGE_INVOICE:
      return { ...state, charging: true, chargeError: null };
    case CHARGE_INVOICE_SUCCESS:
      return { ...state, charging: false };
    case CHARGE_INVOICE_ERROR:
      return { ...state, charging: false, chargeError: payload };
    case ON_UPDATE_INVOICE_STATUS:
      return { ...state, updatingStatus: true, statusError: null };
    case UPDATE_INVOICE_STATUS_SUCCESS:
      return {
        ...state,
        updatingStatus: false,
        // Keep the manually-populated items (booking / changeRequest) from the
        // detail fetch; the status endpoint returns only invoice-level fields.
        invoiceDetail: state.invoiceDetail
          ? { ...state.invoiceDetail, ...payload, items: state.invoiceDetail.items }
          : payload,
      };
    case UPDATE_INVOICE_STATUS_ERROR:
      return { ...state, updatingStatus: false, statusError: payload };
    case GET_INVOICE_PERIODS:
      return { ...state, periods: payload };
    case INVOICE_ERROR:
      return { ...state, error: payload, loading: false, loadingDetail: false };
    default:
      return state;
  }
}
